import styled from "styled-components";
import { gridConfig } from "@tvg/fuse-responsive-grid";

export const StyledCloseContainer = styled.div<{ originalWidth: number }>`
  display: none;
  width: ${({ originalWidth }) => `${originalWidth}px`};
  margin-left: var(--spacing-space24);
  padding-right: var(--spacing-space24);
  justify-content: flex-end;

  @media screen and (min-width: ${gridConfig.l.minWidth}) {
    display: flex;
  }
`;
